export default __webpack_public_path__ + "static/media/settings.4c85c7af.png";